module.exports = __webpack_public_path__ + "img/weylchem-2.bae3f5e6.png";